import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import {
  EXTERNAL_PARTNERS_AND_ADVISERS_NAMES,
  WORK_EXPERIENCE_NAMES as EXTERNAL_PARTNERS_WORK_EXPERIENCE_NAMES,
  LIST_OF_EXTERNAL_PARTNERS_NAMES,
} from 'components/BusinessToolForm/Sections/ManagementAndOrganization/ExternalPartners/utils/form';
import {
  INSTITUTION_NAMES,
  MANAGEMENT_TEAM_NAMES,
  PERSONNEL_PROFILES_NAMES,
  WORK_EXPERIENCE_NAMES,
} from 'components/BusinessToolForm/Sections/ManagementAndOrganization/ManagementTeam/utils/form';
import {
  LEVEL2_DEPARTMENT_NAMES,
  LEVEL3_DEPARTMENT_NAMES,
  STAFF_ORGANIZATION_NAMES,
} from 'components/BusinessToolForm/Sections/ManagementAndOrganization/StaffOrganization/utils/form';

import { ul } from '../helpers';

const LIST_OF_INSTITUTIONS_INSTRUCTIONS = {
  [INSTITUTION_NAMES.NAME]: {
    name: 'Nombre de la institución',
    instruction: 'Indique el nombre completo de las instituciones educativas en las que estudió.',
    exampleOne: 'American University',
    exampleTwo: 'Oklahoma State University',
  },

  [INSTITUTION_NAMES.SPECIALIZATION]: {
    name: 'Especialización',
    instruction: 'Especifique el área de especialización o la titulación principal del personal clave.',
    exampleOne: 'Ingeniería',
    exampleTwo: 'Finanzas',
  },
};

const WORK_EXPERIENCE_INSTRUCTIONS = {
  [WORK_EXPERIENCE_NAMES.EMPLOYER]: {
    name: 'Nombre del empleador',
    instruction: 'Indique el nombre completo de la empresa u organización empleadora.',
    exampleOne: 'John Deere',
    exampleTwo: 'ARP Dend',
  },

  [WORK_EXPERIENCE_NAMES.POSITION]: {
    name: 'Cargo',
    instruction:
      'Especifique el cargo desempeñado dentro de la organización, describiendo de forma clara y concisa el rol y las principales responsabilidades.',
    exampleOne: 'Director de Ingeniería del Departamento de Desarrollo Agrícola',
    exampleTwo: 'Gerente de Finanzas',
  },

  [WORK_EXPERIENCE_NAMES.FROM]: {
    name: 'Período',
    instruction: 'Indique la cronología de la experiencia laboral, especificando las fechas correspondientes.',
    exampleOne: '2000',
    exampleTwo: '2017',
  },

  [WORK_EXPERIENCE_NAMES.TO]: {
    name: 'Período',
    instruction: 'Indique la cronología de la experiencia laboral, especificando las fechas correspondientes.',
    exampleOne: '2013',
    exampleTwo: '2023',
  },

  [WORK_EXPERIENCE_NAMES.FUNCTIONS]: {
    name: 'Funciones',
    instruction:
      'Describa las responsabilidades y las áreas de trabajo en las que participó esta persona. Destaque cómo sus contribuciones ayudaron a alcanzar los objetivos de la organización.',

    exampleOne:
      'Definición y ejecución de la estrategia tecnológica de la empresa en línea con los objetivos generales del negocio. Liderazgo de los procesos de investigación y desarrollo para impulsar la innovación y mejorar la cartera de productos.',

    exampleTwo:
      'Desarrollo y mantenimiento de modelos financieros para proyectar el rendimiento financiero de la empresa. Análisis de datos financieros para identificar tendencias de ingresos, estructuras de costos y niveles de rentabilidad. Evaluación de riesgos financieros y diseño de estrategias para mitigarlos.',
  },
};
const PERSONNEL_PROFILES_INSTRUCTIONS = {
  [PERSONNEL_PROFILES_NAMES.FILE]: {
    name: '',
    instruction:
      'Suba una fotografía de alta resolución que cumpla con estándares profesionales y refleje la identidad de la empresa.',
    exampleOne: '',
    exampleTwo: '',
  },

  [PERSONNEL_PROFILES_NAMES.NAME]: {
    name: 'Nombre',
    instruction: 'Indique el nombre completo del miembro clave del equipo en el formato: Nombre seguido de Apellidos.',
    exampleOne: 'Oliver',
    exampleTwo: 'Mary',
  },

  [PERSONNEL_PROFILES_NAMES.SURNAME]: {
    name: 'Apellidos',
    instruction: 'Indique el nombre completo del miembro clave del equipo en el formato: Nombre seguido de Apellidos.',
    exampleOne: 'Smith',
    exampleTwo: 'Wilson',
  },

  [PERSONNEL_PROFILES_NAMES.DATE_OF_BIRTH]: {
    name: 'Fecha de nacimiento',
    instruction: 'Indique la fecha de nacimiento en un formato claro, incluyendo día, mes y año.',
    exampleOne: '01.01.1975',
    exampleTwo: '02.05.1983',
  },

  [PERSONNEL_PROFILES_NAMES.POSITION]: {
    name: 'Cargo actual',
    instruction:
      'Especifique el cargo que ocupa dentro de la organización, describiendo de forma clara y concisa su función y principales responsabilidades.',
    exampleOne: 'Director de Tecnología (CTO)',
    exampleTwo: 'Gerente de Finanzas',
  },

  [PERSONNEL_PROFILES_NAMES.LIST_OF_INSTITUTIONS]: LIST_OF_INSTITUTIONS_INSTRUCTIONS,

  [PERSONNEL_PROFILES_NAMES.WORK_EXPERIENCE]: WORK_EXPERIENCE_INSTRUCTIONS,

  [PERSONNEL_PROFILES_NAMES.KEY_SKILLS]: {
    name: 'Competencias clave',
    instruction:
      'Enumere las competencias esenciales que respaldan el desempeño exitoso de este directivo. Destaque aquellas capacidades que demuestran su idoneidad para el cargo.',

    exampleOne: ul([
      'Ingeniería mecánica',
      'Diseño de maquinaria agrícola',
      'Gestión de proyectos',
      'Liderazgo',
      'Resolución de problemas técnicos',
    ]),

    exampleTwo: ul([
      'Planificación y análisis financiero',
      'Elaboración de presupuestos',
      'Proyecciones financieras',
      'Informes financieros',
      'Resolución de problemas',
    ]),
  },

  [PERSONNEL_PROFILES_NAMES.ACHIEVEMENTS]: {
    name: 'Logros destacados',
    instruction:
      'Presente un resumen de los principales logros profesionales de esta persona. Destaque su experiencia especializada, así como los hitos, certificaciones o reconocimientos que acreditan un alto nivel de competencia en su campo.',

    exampleOne:
      'En John Deere desempeñó un papel fundamental en el desarrollo de sistemas de motores para maquinaria industrial. Participa cada año en exposiciones internacionales del sector, entre ellas International EXPO e Innovation Chicago. Además, ocupó durante cinco años consecutivos los primeros puestos del ranking Promising Engineers de Connecticut.',

    exampleTwo:
      'Titular de la certificación Chartered Financial Analyst (CFA). Mary ha sido reconocida por sus destacadas contribuciones al sector financiero, recibiendo galardones como Financial Excellence Award 2020 y Finance Professional of the Year Award 2021.',
  },
};
const MANAGEMENT_TEAM_INSTRUCTIONS = {
  [MANAGEMENT_TEAM_NAMES.HISTORY]: {
    name: 'Historia y trayectoria',

    instruction:
      'Describa cómo se formó el equipo directivo. Explique el proceso de incorporación de sus miembros, las etapas clave de su desarrollo, el perfil profesional de cada integrante y su contribución al crecimiento de la empresa. Destaque la experiencia y el conocimiento estratégico que aporta cada miembro.',

    exampleOne:
      'La empresa fue fundada por los estadounidenses John Johnson y Oliver Smith. John Johnson, propietario de una empresa agrícola en Texas, unió fuerzas con Oliver Smith, ingeniero de John Deere, reconocido fabricante de maquinaria agrícola, de construcción y forestal. La combinación de experiencia empresarial y conocimiento técnico sentó las bases para el crecimiento de la compañía.',

    exampleTwo:
      'Los principales integrantes del proyecto son John Johnson y Mary Wilson. John Johnson, graduado en Programación, fundó la empresa junto con Mary Wilson, especialista en Finanzas por la misma universidad. La combinación de sus perfiles técnicos y financieros permitió construir un modelo de negocio sólido y escalable.',
  },

  [MANAGEMENT_TEAM_NAMES.SKILLS]: {
    name: 'Competencias y capacidades',

    instruction:
      'Describa las principales competencias del equipo directivo. Destaque las capacidades de liderazgo, la experiencia profesional y los conocimientos especializados que posicionan al equipo para dirigir con éxito la empresa. Centre la atención en aquellas fortalezas que generan una ventaja competitiva y contribuyen al crecimiento del negocio.',

    exampleOne:
      'La amplia experiencia del equipo directivo en el sector, junto con sus capacidades de gestión empresarial y liderazgo, constituye una sólida base para el crecimiento de la empresa. La visión emprendedora y el profundo conocimiento del mercado de John Johnson, combinados con la experiencia técnica de Oliver Smith, impulsan la innovación y la ejecución de la estrategia corporativa.',

    exampleTwo:
      'La experiencia de John Johnson en desarrollo de software constituye el núcleo tecnológico de la plataforma. Además, diseñó la arquitectura de la primera versión del producto. Por su parte, Mary Wilson aporta una sólida trayectoria en departamentos financieros de distintas compañías, fortaleciendo la planificación y la gestión financiera del negocio.',
  },

  [MANAGEMENT_TEAM_NAMES.PERSONAL_QUALITIES]: {
    name: 'Cualidades personales',

    instruction:
      'Describa las cualidades personales del equipo directivo, prestando especial atención a habilidades como liderazgo, comunicación, adaptabilidad, resiliencia y trabajo en equipo. Destaque aquellas características que contribuyen al cumplimiento de los objetivos estratégicos de la empresa y fortalecen su competitividad.',

    exampleOne:
      'El equipo directivo combina sólidas capacidades de liderazgo con una amplia experiencia profesional. La gestión de la empresa durante la pandemia de COVID-19 demostró una gran capacidad de adaptación ante cambios del entorno. Sus habilidades interpersonales permitieron mantener la cohesión del equipo, gestionar situaciones complejas y responder con eficacia a nuevos desafíos.',

    exampleTwo:
      'La resiliencia, la adaptabilidad, la colaboración y la innovación forman parte de la cultura del equipo directivo. Estas cualidades favorecen un entorno de trabajo dinámico, impulsan la mejora continua y permiten a la empresa afrontar los desafíos del mercado con agilidad.',
  },

  [MANAGEMENT_TEAM_NAMES.PERSONNEL_PROFILES]: PERSONNEL_PROFILES_INSTRUCTIONS,
};
const EXTERNAL_PARTNERS_WORK_EXPERIENCE_INSTRUCTIONS = {
  [EXTERNAL_PARTNERS_WORK_EXPERIENCE_NAMES.EMPLOYER]: {
    name: 'Nombre del empleador',
    instruction: 'Indique el nombre completo de la empresa u organización.',
    exampleOne: 'Lint',
    exampleTwo: 'A&Partners',
  },

  [EXTERNAL_PARTNERS_WORK_EXPERIENCE_NAMES.POSITION]: {
    name: 'Cargo',
    instruction:
      'Especifique el cargo desempeñado por el socio o consultor dentro de la organización, describiendo de forma clara y concisa sus funciones y responsabilidades.',
    exampleOne: 'Desarrollador de software',
    exampleTwo: 'Abogado especializado en contratos',
  },
};

const LIST_OF_EXTERNAL_PARTNERS_INSTRUCTIONS = {
  [LIST_OF_EXTERNAL_PARTNERS_NAMES.FILE]: {
    name: '',
    instruction:
      'Suba una fotografía de alta resolución que cumpla con estándares profesionales y refleje la identidad de la empresa.',
    exampleOne: '',
    exampleTwo: '',
  },

  [LIST_OF_EXTERNAL_PARTNERS_NAMES.NAME]: {
    name: 'Nombre',
    instruction: 'Indique el nombre completo del socio clave en el formato: Nombre seguido de Apellidos.',
    exampleOne: 'Alex',
    exampleTwo: 'Camila',
  },

  [LIST_OF_EXTERNAL_PARTNERS_NAMES.SURNAME]: {
    name: 'Apellidos',
    instruction: 'Indique el nombre completo del socio clave en el formato: Nombre seguido de Apellidos.',
    exampleOne: 'Leto',
    exampleTwo: 'Devis',
  },

  [LIST_OF_EXTERNAL_PARTNERS_NAMES.ROLE]: {
    name: 'Rol en la empresa',
    instruction:
      'Especifique el rol o función que desempeña este socio dentro de la empresa, destacando claramente sus principales responsabilidades.',
    exampleOne: 'Consultor de TI',
    exampleTwo: 'Asesor jurídico',
  },

  [LIST_OF_EXTERNAL_PARTNERS_NAMES.WORK_EXPERIENCE]: EXTERNAL_PARTNERS_WORK_EXPERIENCE_INSTRUCTIONS,

  [LIST_OF_EXTERNAL_PARTNERS_NAMES.KEY_SKILLS]: {
    name: 'Competencias clave',
    instruction:
      'Enumere las principales competencias del consultor o socio externo. Destaque los conocimientos y capacidades que aportan valor a su función.',

    exampleOne: 'Estrategia y planificación de TI\nCiberseguridad\nDesarrollo de software',

    exampleTwo: 'Cumplimiento normativo\nProtección de la propiedad intelectual\nFormación jurídica',
  },
};

const EXTERNAL_PARTNERS_AND_ADVISERS_INSTRUCTIONS = {
  [EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.LIST_OF_EXTERNAL_PARTNERS]: LIST_OF_EXTERNAL_PARTNERS_INSTRUCTIONS,

  [EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.PARTNERS]: {
    name: 'Experiencia de los socios',

    instruction:
      'Describa los socios estratégicos y consultores con los que colabora la empresa. Explique el área de especialización de cada uno y cómo su experiencia contribuye al logro de los objetivos empresariales.',

    exampleOne:
      'La empresa colabora con la consultora tecnológica ABCD, especializada en infraestructura tecnológica, ciberseguridad y desarrollo de software. Su experiencia permite implementar y mantener soluciones tecnológicas seguras y escalables.',

    exampleTwo:
      'La empresa trabaja con la asesora jurídica Camila Davis para garantizar el cumplimiento normativo y reducir los riesgos legales. Asimismo, la agencia de marketing ABC aporta experiencia en marketing digital, branding y publicidad, fortaleciendo el posicionamiento de la empresa y su alcance en el mercado.',
  },

  [EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.CRITERIA]: {
    name: 'Criterios de selección',

    instruction:
      'Describa los criterios utilizados para seleccionar socios y consultores, como experiencia demostrada, proyectos exitosos, referencias de clientes, reputación en el sector, compatibilidad con la empresa o alineación con sus objetivos estratégicos. Destaque por qué estos colaboradores aportan el conocimiento especializado necesario para el proyecto.',

    exampleOne:
      'El principal criterio para seleccionar socios es su experiencia y conocimiento especializado. La empresa prioriza colaboradores con una trayectoria sólida y resultados comprobados en áreas relevantes.',

    exampleTwo:
      'La empresa evalúa la experiencia, la reputación y la rentabilidad de cada socio potencial. También valora la fiabilidad, la capacidad para cumplir plazos, mantener la confidencialidad y ofrecer soluciones competitivas alineadas con los objetivos del negocio.',
  },

  [EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.PLANS]: {
    name: 'Planes de expansión',

    instruction:
      'Describa los planes para ampliar la red de socios y asesores. Explique las razones estratégicas de esta expansión, como el acceso a nuevos mercados, la incorporación de nuevas capacidades o la diversificación del conocimiento, así como los beneficios esperados para la empresa.',

    exampleOne:
      'La empresa prevé ampliar su red de socios y asesores para incorporar nuevas perspectivas y conocimientos especializados que fortalezcan la toma de decisiones estratégicas y mejoren el rendimiento del negocio.',

    exampleTwo:
      'Como parte de su estrategia de crecimiento, la empresa planea incorporar un asesor financiero procedente de un fondo de inversión para optimizar la gestión financiera y reforzar la planificación de futuras operaciones de financiación.',
  },
};
const LEVEL2_DEPARTMENT_INSTRUCTIONS = {
  [LEVEL2_DEPARTMENT_NAMES.DEPARTMENT]: {
    name: 'Estructura organizativa',
    instruction:
      'Describa la estructura organizativa de la empresa, explicando cómo colaboran los distintos departamentos o unidades para alcanzar los objetivos comunes.',
    exampleOne: '',
    exampleTwo: '',
  },
};

const LEVEL3_DEPARTMENT_INSTRUCTIONS = {
  [LEVEL3_DEPARTMENT_NAMES.DEPARTMENT]: {
    name: 'Estructura organizativa',
    instruction:
      'Describa la estructura organizativa de la empresa, explicando cómo colaboran los distintos departamentos o unidades para alcanzar los objetivos comunes.',
    exampleOne: '',
    exampleTwo: '',
  },
};

const STAFF_ORGANIZATION_INSTRUCTIONS = {
  [STAFF_ORGANIZATION_NAMES.NUMBER_OF_STAFF]: {
    name: 'Plantilla y estructura',

    instruction:
      'Proporcione una visión general de la plantilla actual de la empresa. Indique el número total de empleados y describa brevemente cómo se distribuyen entre los principales departamentos o equipos.',

    exampleOne:
      'Actualmente, la empresa cuenta con 50 empleados distribuidos en cinco departamentos: Marketing y Ventas, Producción, Recursos Humanos, Finanzas e Investigación y Desarrollo.',

    exampleTwo:
      'La empresa cuenta actualmente con 12 empleados organizados en tres departamentos. El departamento técnico desarrolla y mantiene la plataforma; el departamento operativo gestiona los recursos humanos y el marketing; y el departamento financiero supervisa la planificación y la gestión financiera.',
  },

  [STAFF_ORGANIZATION_NAMES.LEVEL1_DEPARTMENT]: {
    name: 'Estructura organizativa',

    instruction:
      'Describa la estructura organizativa de la empresa, explicando cómo colaboran los distintos departamentos o unidades para alcanzar los objetivos comunes.',

    exampleOne: '',
    exampleTwo: '',
  },

  [STAFF_ORGANIZATION_NAMES.LEVEL2_DEPARTMENT]: LEVEL2_DEPARTMENT_INSTRUCTIONS,

  [STAFF_ORGANIZATION_NAMES.LEVEL3_DEPARTMENT]: LEVEL3_DEPARTMENT_INSTRUCTIONS,

  [STAFF_ORGANIZATION_NAMES.SKILLS]: {
    name: 'Competencias y cualificaciones',

    instruction:
      'Describa las competencias, cualificaciones y experiencia que considera esenciales para que los empleados desempeñen con éxito sus funciones. Incluya conocimientos técnicos, formación académica y experiencia profesional relevante de forma clara y concisa.',

    exampleOne:
      'Los empleados deben contar con formación en Ingeniería Mecánica o una disciplina equivalente, experiencia en diseño de maquinaria pesada, capacidad para resolver problemas, conocimiento del sector agrícola, habilidades de comunicación y experiencia en trabajo colaborativo. También se valorará el conocimiento de la normativa medioambiental.',

    exampleTwo:
      'Los desarrolladores de la plataforma deben dominar lenguajes de programación como Python, JavaScript o Java. Asimismo, se requiere experiencia en desarrollo de software, gestión de bases de datos y plataformas de computación en la nube como AWS o Azure.',
  },

  [STAFF_ORGANIZATION_NAMES.ADDITIONAL_HIRES]: {
    name: 'Necesidades de contratación',

    instruction:
      'Indique los perfiles profesionales y el número de incorporaciones necesarias para ejecutar el proyecto. Describa las funciones, competencias y conocimientos especializados que deberán aportar los nuevos integrantes del equipo.',

    exampleOne:
      'El proyecto requiere la incorporación de 15 nuevos empleados: cinco ingenieros de desarrollo con experiencia en diseño de maquinaria agrícola y diez especialistas técnicos para el área de Producción, con el fin de responder al aumento previsto de la capacidad de fabricación.',

    exampleTwo:
      'El plan de crecimiento contempla la incorporación de un Coordinador de Proyectos, responsable de coordinar las actividades del proyecto y gestionar la documentación. El candidato deberá contar con excelentes capacidades de organización, comunicación y gestión simultánea de múltiples tareas.',
  },

  [STAFF_ORGANIZATION_NAMES.APPROACHES]: {
    name: 'Estrategia de contratación',

    instruction:
      'Describa la estrategia de contratación de la empresa. Indique quiénes son responsables del proceso de selección y explique los métodos utilizados para atraer, evaluar e incorporar a los mejores candidatos.',

    exampleOne:
      'El Departamento de Recursos Humanos será responsable del proceso de contratación. La empresa utiliza sistemas de seguimiento de candidatos (ATS) para gestionar las ofertas de empleo, las solicitudes y la comunicación con los candidatos durante todo el proceso de selección.',

    exampleTwo:
      'El Gerente de Recursos Humanos, Theodore Swift, supervisará los procesos de selección e incorporación. Para optimizar el reclutamiento, la empresa utiliza portales de empleo y software especializado para identificar y evaluar candidatos de manera eficiente.',
  },

  [STAFF_ORGANIZATION_NAMES.ATTRACTING_DIFFICULTIES]: {
    name: 'Desafíos para atraer talento',

    instruction:
      'Describa los principales desafíos relacionados con la atracción de talento. Considere factores como la escasez de profesionales cualificados, la alta competencia en el mercado laboral o el desajuste entre las competencias disponibles y las necesidades de la empresa.',

    exampleOne:
      'La empresa afronta desafíos relacionados con la disponibilidad limitada de profesionales cualificados y la fuerte competencia por perfiles técnicos especializados. Encontrar candidatos con experiencia en determinadas áreas resulta especialmente complejo, sobre todo en regiones con menor disponibilidad de talento.',

    exampleTwo:
      'La contratación de profesionales altamente cualificados supone un reto debido a la intensa competencia del mercado. Los especialistas con experiencia suelen esperar paquetes retributivos y beneficios más competitivos.',
  },

  [STAFF_ORGANIZATION_NAMES.SALARY_POLICY]: {
    name: 'Política de compensación y motivación',

    instruction:
      'Describa la política salarial de la empresa en relación con el mercado. Explique los programas de incentivos existentes, como bonificaciones, participación en beneficios, reconocimientos u otros mecanismos de motivación, indicando cómo se vinculan al desempeño.',

    exampleOne:
      'La empresa ofrece una política retributiva superior a la media del mercado para atraer y retener talento de alto nivel. Además, dispone de programas de participación en beneficios, sistemas de reconocimiento y bonificaciones vinculadas al rendimiento.',

    exampleTwo:
      'La política salarial se mantiene alineada con las condiciones del mercado y se complementa con incentivos basados en el desempeño individual y colectivo, garantizando la alineación entre los objetivos de los empleados y los de la empresa.',
  },

  [STAFF_ORGANIZATION_NAMES.RETENTION_DIFFICULTIES]: {
    name: 'Retención del talento',

    instruction:
      'Describa los principales desafíos relacionados con la retención del talento y explique las iniciativas implementadas para aumentar el compromiso y la permanencia de los empleados, como oportunidades de desarrollo profesional, compensación competitiva, programas de reconocimiento o una cultura laboral inclusiva.',

    exampleOne:
      'La empresa afronta desafíos derivados de la exigencia física del trabajo y de las fluctuaciones estacionales de la carga laboral. Para mejorar la retención, ofrece una compensación competitiva, oportunidades de desarrollo profesional, programas de reconocimiento y medidas para favorecer el equilibrio entre la vida laboral y personal.',

    exampleTwo:
      'Entre los principales desafíos se encuentran la competencia por el talento y la satisfacción laboral. Para fortalecer la fidelización de los empleados, la empresa invierte en formación continua, planes de desarrollo profesional, una cultura organizativa inclusiva y un paquete de beneficios competitivo.',
  },

  [STAFF_ORGANIZATION_NAMES.DEVELOPMENT_PROGRAMS]: {
    name: 'Programas de formación y desarrollo',

    instruction:
      'Describa los programas de formación y desarrollo profesional disponibles para los empleados. Explique cómo se capacita al personal nuevo y existente, destacando la importancia del aprendizaje continuo para fortalecer las competencias y contribuir al logro de los objetivos estratégicos de la empresa.',

    exampleOne:
      'La empresa implementará un programa integral de formación para garantizar que los empleados desarrollen las competencias necesarias para desempeñar sus funciones con éxito. El proceso incluye un programa de incorporación estructurado, así como acceso continuo a talleres, seminarios, webinars y cursos en línea.',

    exampleTwo:
      'La empresa apuesta por una estrategia de aprendizaje continuo. Se organizan talleres periódicos para fortalecer competencias en gestión de proyectos, comunicación y atención al cliente. Además, los empleados tienen acceso a cursos externos y certificaciones profesionales para seguir desarrollando su experiencia.',
  },
};

export const MANAGEMENT_AND_ORGANIZATION_INSTRUCTIONS = {
  [BUSINESS_TOOL_SUB_SECTIONS.MANAGEMENT_AND_ORGANIZATION.MANAGEMENT_TEAM]: MANAGEMENT_TEAM_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.MANAGEMENT_AND_ORGANIZATION.EXTERNAL_PARTNERS_AND_ADVISERS]:
    EXTERNAL_PARTNERS_AND_ADVISERS_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.MANAGEMENT_AND_ORGANIZATION.STAFF_ORGANIZATION]: STAFF_ORGANIZATION_INSTRUCTIONS,
};
